import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { QuestionOptionSubOptions } from "./sub-options";
import { useSubOptions } from "./sub-options/hooks";

export const QuestionOptionSubOption = () => {
	const { subOptions, onSetSubOptionName } = useSubOptions();

	const title = "サブオプションの設定";
	const guide =
		"オプションに複数の選択肢を与えることができます。<br /><br />サブオプションはそれぞれ個別に在庫管理が可能ですが、合計在庫数がオプション全体の在庫数を超えないように設定されています。<br/> 時間帯がある場合は、開始時刻と終了時刻を入力してください。 また、終了時刻が日を跨ぐ場合は24以降の数字で指定してください。<br /><br />入力例）午前第一部、昼食(並)";

	const isEdited = subOptions?.isEdited || false;
	const hasError = subOptions?.hasError || false;

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			guide={guide}
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="flex flex-col gap-y-10">
					<>
						{subOptions && subOptions.value?.length && subOptions.value.length > 0 ? (
							<QuestionOptionSubOptions subOptions={subOptions} onSetSubOptionName={onSetSubOptionName} />
						) : (
							<p>サブオプションの設定をしていません</p>
						)}
					</>
				</div>
			}
		/>
	);
};
